var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'register-page__row-contacts': _vm.isRow}},[_c('a',{staticClass:"register-page__email",attrs:{"href":("mailto:" + _vm.email)}},[_c('icu-icon',{staticClass:"pc-email"}),_vm._v(" "+_vm._s(_vm.email)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }